import React from "react";
import { isFeatureEnabled } from "utility/isFeatureEnabled";

import StreamingLiveCommerceShopify from "./StreamingLiveCommerceShopify";
import StreamingLiveCommerceV2 from "./StreamingLiveCommerceV2";

type Props = React.ComponentProps<typeof StreamingLiveCommerceV2>;

/**
 * newLiveCommerceフラグでGMO版とShopify版を切り替える。
 * ナビのサムネイルも同じフラグを見る。公開後に一緒に消す相手は
 * useStreamingNavigationGoods。
 *
 * フラグは公開前の一時的なもの。公開後はShopify版だけが購入導線になるので、
 * このファイルとGMO版 (StreamingLiveCommerceV2と専用の子コンポーネント) を消し、
 * 呼び出し側をStreamingLiveCommerceShopifyに向ければよい。
 * ナビ側はuseStreamingNavigationGoodsのFirestore分岐とisFeatureEnabledを消す。
 */
const StreamingLiveCommerce: React.FC<Props> = (props) => {
  if (isFeatureEnabled({ featureName: "newLiveCommerce" })) {
    return (
      <StreamingLiveCommerceShopify
        THEOPlayerElementHeight={props.THEOPlayerElementHeight}
      />
    );
  }
  return <StreamingLiveCommerceV2 {...props} />;
};

export default StreamingLiveCommerce;
